// Path: ./src/app/pages/CreateCoupon/index.tsx
import React from "react";
import LogoSrc from "../../assets/GoFlyer_Logo_2022Feb-10.png";
import { Container, Logo, Text } from "./styled";

const CreateCoupon = () => {
  return (
    <Container data-testid="createcoupon-test-id">
      <Logo src={LogoSrc} alt="Logo" />
      <Text>Create Coupon page is in Progress</Text>
    </Container>
  );
};

export default CreateCoupon;
